import { render, staticRenderFns } from "./applicant-request-component.vue?vue&type=template&id=5513e196&"
import script from "./applicant-request-component.vue?vue&type=script&lang=ts&"
export * from "./applicant-request-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports